import BEEINVEST_EXT_1 from "./BEEINVEST_EXT_1";
export default {
  BEEINVEST_EXT_1,
};
